<!--
 * @Descripttion: 热门推荐组件
 * @Author: Yang Maoxiang
 * @Date: 2020-08-27 16:58:14
 * @LastEditTime: 2023-04-17 11:07:21
-->
<template>
  <div class="recommend" v-if="showcheck">
    <div class="title">热门推荐</div>
    <div class="scroll">
      <div class="content">
        <v-scroll-x :data="config" resizeFlag>
          <template v-slot="{ data: y, index }">
            <div
              tabindex="0"
              v-track="{
                act: 'show',
                params: {
                  cfrom: '5340',
                  event_id: '081|010|02|077',
                  page_name: 1,
                  sku_id: commonTrackData.sku_id,
                  module: 4,
                  position: index + 1,
                  recommend_id: y.id,
                  main_price: mainPrice,
                  recommend_price: y.salePrice,
                  ab_id: y.abId || 'ai-local',
                  recommendation_type: recommendType(y.recallSource),
                  pagetype: commonTrackData.page_type,
                  page_type: commonTrackData.page_type,
                  trace_id: y.traceId
                }
              }"
              @click="toDetail(y, index)"
              class="item"
            >
              <img class="product-img" v-lazy="y.imgUrl" alt v-if="y.imgUrl" />
              <div class="name">{{ y.name }}</div>
              <div class="desc" v-if="y.brief">{{ y.brief }}</div>
              <div class="price" :aria-label="`￥${y.salePrice}`">
                <span class="yen">¥</span>
                <span>{{ y.salePrice | formatNumber }}</span>
                <!-- <span class="market">¥{{ y.marketPrice | formatNumber }}</span> -->
              </div>
            </div>
          </template>
        </v-scroll-x>
      </div>
    </div>
  </div>
</template>

<script>
import { jumpToShop } from '@/utils/common'
import { app } from '@/utils'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'Recommend',
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto'
      }
    }
  },
  computed: {
    ...mapState('detailv3', ['recommendList', 'spuInfo']),
    ...mapGetters('detailv3', ['commonTrackData', 'mainPrice']),
    config() {
      return this.recommendList && this.recommendList.similarRecomms
    },
    modelVersion() {
      return (this.recommendList && this.recommendList.modelVersion) || 0
    },
    showcheck() {
      var bol =
        this.recommendList &&
        this.recommendList.similarRecomms &&
        this.recommendList.similarRecomms.length != 0 &&
        this.spuInfo
      return bol
    }
  },
  methods: {
    /**
     * @description: 跳转详情页
     * @Author: Yang Maoxiang
     * @Date: 2020-08-28 11:34:01
     */
    toDetail(y, index) {
      this.$track({
        cfrom: '5341',
        event_id: '081|010|01|077',
        page_name: 1,
        sku_id: this.commonTrackData.sku_id,
        module: 4,
        position: index + 1,
        recommend_id: y.id,
        main_price: this.mainPrice,
        recommend_price: y.salePrice,
        ab_id: y.abId || 'ai-local',
        recommendation_type: this.recommendType(y.recallSource),
        page_type: this.commonTrackData.page_type
      })
      // jumpToShop(y.url)
      const link = `${this.linkBase}${y.url}`
      app.openNewWebview({
        url: link
      })
    },
    recommendType(recallSource) {
      /**
       * recallSource
       * 0：算法，1：管理平台运营配置，2：从DMP召回，3：大数据，4：失败异常回放，5：其他渠道获得，6：人工干预
       */
      if (recallSource) {
        let type = 0
        if (recallSource == 6){
          // 人工单独标记，其它统一归为算法（0）
          type = recallSource
        }
        // 被分流到端智能，但是被人工优先了
        if (this.modelVersion) {
          type += '-' + this.modelVersion
        }
        return type
      } else if (this.modelVersion) {
        return this.modelVersion
      }
      return 0
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-5 {
  .scroll .content .item .name {
    height: 58px;
  }
}
</style>
